<template>
    <Button size="small" :label="label ?? t('billing.open-portal')" icon="pi pi-external-link" :loading="portalLoading"
        @click="onOpenPortalClicked" />
</template>

<script setup lang="ts">
import { ref } from 'vue'
import Button from 'primevue/button'
import { useI18n } from 'vue-i18n'
import { useBillingStore } from '@/stores/billing'
import { logger } from '@/utils/logger'
import { trackAction } from '@/composables/useActivityTracker'
import { CsmAction } from '@/constants/csmActions'

const props = defineProps<{
    label?: string
}>()

const { t } = useI18n()
const billingStore = useBillingStore()

const portalLoading = ref(false)

async function onOpenPortalClicked() {
    if (portalLoading.value) return
    portalLoading.value = true
    billingStore
        .requestCustomerPortalUrlRefresh()
        .then((url) => {
            if (url) {
                try { trackAction(CsmAction.BillingPortalOpened) } catch { /* best-effort */ }
                const opened = window.open(url, '_blank')
                if (!opened) {
                    window.location.href = url
                }
            }
        })
        .catch((e) => {
            logger.error('Error opening customer portal', e)
        })
        .finally(() => {
            portalLoading.value = false
        })
}
</script>
